import qs from "qs";
import getInfoObject from "@/helpers/get-info-object";
import axios from "axios";
import serviceEnv from "./env";
import getRequestHeaders from "@/helpers/get-request-headers";
import setWithExpiry from "@/helpers/set-with-expiry";

class rubyIdentService {
    constructor() {
        this.config = serviceEnv.config;
    }

    /**
     * @param {Object} user
     * @returns {Promise<Object>}
     */
    loginUser(user) {
        return new Promise((resolve, reject) => {
            const params = qs.stringify({
                'Key': this.config.serviceKey,
                'Id': this.config.serviceId,
                'Ver': this.config.serviceInfoObjectVersion,
                'EnL': this.config.serviceInfoObjectEncryptionLevel,
                'EnK': this.config.serviceInfoObjectEncryptionKey
            });

            const payload = {
                event: "AUTHENTICATION_LOGIN_USER",
                username: user.username,
                password: user.password
            };

            const data = JSON.stringify(getInfoObject(payload, 'p00019'));

            const config = {
                headers: getRequestHeaders()
            };

            const url = this.config.serviceUrl + '/' + this.config.servicePortfolioElement + '/info?' + params;

            axios.post(url, data, config)
                .then(response => {
                    let userData = false;

                    if (response.status === 200) {
                        userData  = response.data.container[0].payload.data;

                        const loggedInUser = {
                            id: userData.id,
                            email: userData.email,
                            firstName: userData.firstName,
                            lastName: userData.lastName,
                            token: userData.token
                        };

                        setWithExpiry('user', loggedInUser, userData.tokenExpiresInSeconds);

                        userData = loggedInUser;
                    }

                    resolve(userData);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @returns {Promise<empty>}
     */
    logoutUser() {
        return new Promise((resolve) => {
            localStorage.removeItem('user');
            resolve();
        });
    }
}

export default new rubyIdentService();